import SimpleScrollbar from './index.vue';

export default SimpleScrollbar as any;
